module.exports = __webpack_public_path__ + "img/0-discord.22eace83.webp";